import { ACTIVITY_TYPES } from '@/v2/domains/Activities/constants/types';

const NOT_ASSIGNABLE_TO_STUDENT_TYPES = [
  ACTIVITY_TYPES.worksheet,
  ACTIVITY_TYPES.craft,
  ACTIVITY_TYPES.pictureDictionary,
  ACTIVITY_TYPES.realTime,
];

export default function filterNotAssignableActivities(activities) {
  return activities.filter(
    (activity) => !NOT_ASSIGNABLE_TO_STUDENT_TYPES.includes(activity.type)
  );
}
